import { ANALYTICS_HEAP_IDS, formatHeapId } from '@/common/constants';
import {
  ExpansionPanelContent,
  ExpansionPanelTrigger,
  ExpansionPanel as MarmaladeExpansionPanel,
} from '@eventbrite/marmalade';
import React from 'react';
import { SectionProps } from '../types';
import styles from './MarketingSectionBlockMobile.module.scss';

export const MarketingSectionBlockMobile: React.FC<SectionProps> = ({
  sectionName,
  marketingLinks,
  defaultOpen = false,
}) => {
  return (
    <div className={styles['marketing-section-mobile']}>
      <MarmaladeExpansionPanel
        className={styles['expansion-panel']}
        defaultOpen={defaultOpen}
        variant="default"
        id="expansion-panel"
        role="region"
        placeholder="Expansion-Panel"
        onPointerEnterCapture={() => {}}
        onPointerLeaveCapture={() => {}}
      >
        <ExpansionPanelTrigger
          className={styles['section-title']}
          id="panel-trigger"
          role="button"
          placeholder="Panel-Trigger"
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          {sectionName}
        </ExpansionPanelTrigger>
        <ExpansionPanelContent
          className={styles['expansion-panel-content']}
          id="panel-content"
          role="region"
          placeholder="Panel-Content"
          onPointerEnterCapture={() => {}}
          onPointerLeaveCapture={() => {}}
        >
          <ul className={styles['list-container']}>
            {marketingLinks.map((link, index) => (
              <li key={`Mobile-${sectionName}-${link.text}-${link.link}-${index}`}>
                <a
                  href={link.link}
                  data-heap-id={formatHeapId([
                    ANALYTICS_HEAP_IDS.MOBILE,
                    ANALYTICS_HEAP_IDS.FOOTER_MARKETING,
                    sectionName,
                    link.text,
                  ])}
                >
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        </ExpansionPanelContent>
      </MarmaladeExpansionPanel>
    </div>
  );
};
